<template>
  <div>
    <div class="card" style="height:700px!important">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="listing-section pt-3 pl-3">
        <h3
          class="listing-desc-headline margin-top-60"
          style="font-weight:400!important;margin-bottom:20px"
        >Sightings Location</h3>
      </div>
      <div class="row">
        <div class="col-md-9">
          <h5 class="pt-2 pl-3 pb-3">*Select the options to filter the results</h5>
        </div>
        <!-- <div class="col=md-3">
          <vue-excel-xlsx
            :data="data"
            :columns="columns2"
            :filename="'Sightings'"
            :sheetname="'sheetname'"
            class="btn btn-success"
          >Export to Excel</vue-excel-xlsx>
        </div>-->
      </div>
      <div class="row pl-3 pr-3 pb-3">
        <div class="col-md-2">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;">Please Enter the Purpose</label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="purpose">
              <option value selected disabled hidden>Purpose</option>
              <option v-bind:value="null">All</option>
              <option value="observation">Observation</option>
              <option value="rescue">Rescue</option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left!important;"
            >Please Enter the Turtle Name</label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="turtle">
              <option value disabled selected>Choose a Turtle</option>
              <option v-bind:value="null">All</option>
              <option v-for="itm in turt" :key="itm._id" v-bind:value="itm._id">{{itm.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left!important;"
            >Please Enter the Username</label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="user">
              <option value disabled selected>Choose a User</option>
              <option v-bind:value="null">All</option>
              <option v-for="itm in users" :key="itm._id" v-bind:value="itm._id">{{itm.username}}</option>
            </select>
          </div>
        </div>
        <div v-if="purpose=='observation'" class="col-md-2">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;">Please Enter the Type of turtle</label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="type">
              <option value disabled selected>Choose the type</option>
              <option v-bind:value="null">All</option>
              <option value="wild">Wild</option>
              <option value="zoo">Zoo</option>
              <option value="commercialmarket">Commercial Market</option>
              <option value="personalholding">Personal Holding</option>
              <option value="religiousshrines/communityponds">Religious Shrines/Community Ponds</option>
            </select>
          </div>
        </div>
        <div v-if="purpose=='rescue'" class="col-md-2">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left!important;"
            >Please Enter Situatiion</label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="situation">
              <option value disabled selected>Choose the Situation</option>
              <option value="illegaltrade">Illegal Trade</option>
              <option value="commercialmarket">Commercial Market</option>
              <option value="personalholding">Personal Holding</option>
              <option value="others">Others</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left!important;"
            >Please Select the From Date</label>
            <input
              v-model="from"
              type="date"
              required
              class="pt-2 pb-2"
              placeholder="Project Deadline"
              style="color:black!important;width:100%!important;"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left!important;"
            >Please Select the To date</label>
            <input
              v-model="to"
              type="date"
              required
              class="pt-2 pb-2"
              placeholder="Project Deadline"
              style="color:black!important;width:100%!important;"
            />
          </div>
        </div>
      </div>

      <div id="myMap"></div>
      <!--       
              <div class="col-md-2">
                <div class="form-group">
                  <label for="exampleInputEmail1" style="text-align: left!important;"></label>
                  <select class="filter pt-2 pb-2" style="width:100%!important" v-model="crimeType">
                    <option value selected disabled hidden>Crime Type</option>
                    <option v-bind:value="none">All</option>
                    <option v-for="ct in ctype" :key="ct._id" v-bind:value="ct._id">{{ct.cname}}</option>
                  </select>
                </div>
      </div>-->
    </div>
  </div>
</template>
<script>
import axios from "axios";
var marker;
export default {
  data() {
    return {
      loading: false,
      data: [],
      turt: [],
      users: [],
      user: "",
      turtle: "",
      purpose: "",
      situation: "",
      type: "",
      from: "",
      to: "",
      columns1: [
        {
          label: "Observer/Rescuer",
          field: "empID",
        },
        {
          label: "Employee Name",
          field: "name",
        },
        {
          label: "Employee Email",
          field: "email",
        },
        {
          label: "Attendance Date",
          field: "date",
        },
        {
          label: "Login Time",
          field: "login",
        },
        {
          label: "Logout Time",
          field: "logout",
        },
        {
          label: "Worked Hours",
          field: "workedHours",
        },
      ],
    };
  },
  watch: {
    purpose: function () {
      this.getList();
    },
    turtle: function () {
      this.getList();
    },
    user: function () {
      this.getList();
    },
    type: function () {
      this.getList();
    },
    situation: function () {
      this.getList();
    },

    from: function () {
      this.getList();
    },
    to: function () {
      this.getList();
    },
  },
  mounted: function () {
    this.getList();
    this.getTurtleList();
    this.userList();
  },

  methods: {
    userList() {
      this.loading = true;
      axios({
        method: "GET",
        url: "/user/allUsers?type=User",
        // headers: {
        //   "x-auth-token": localStorage.getItem("token")
        // }
      })
        .then((response) => {
          this.loading = false;

          if (response.data.status === true) {
            this.users = response.data.data;
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },

    getTurtleList() {
      this.loading = true;
      axios({
        method: "GET",
        url: "/turtle/getlist",
      })
        .then((response) => {
          this.loading = false;
          var temp = [];
          if (response.data.status === true) {
            // for (var j = 0; j < response.data.data.length; j++) {
            //   var ty = response.data.data[j].name;
            //   temp.push(ty);
            // }
            // this.turt = temp;
            this.turt = response.data.data;
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },

    getList() {
      this.loading = true;
      if (this.from != "") {
        var fr = this.formatDate(this.from);
      } else var fr = null;
      if (this.to != "") {
        var too = this.formatDate(this.to);
      } else var too = null;
      axios({
        method: "GET",
        url: "/report/getlist",
        params: {
          purpose: this.purpose,
          token: localStorage.getItem("token"),
          turtle: this.turtle,
          user: this.user.situation,
          type: this.type,
          situation: this.situation,
          from: fr,
          to: too,
        },
      })
        .then((response) => {
          // console.log(response.data.data)

          this.loading = false;
          if (response.data.status === true) {
            this.data = response.data.data;
            var mapCanvas = document.getElementById("myMap");

            var mapOptions = {
              center: new google.maps.LatLng(18.53766, 76.884773),
              zoom: 4,

              mapTypeId: google.maps.MapTypeId.TERRAIN,
            };
            var vm = this;

            vm.map = new google.maps.Map(mapCanvas, mapOptions);

            // var data = {};

            for (var i = 0; i < this.data.length; i++) {
              var lat = this.data[i].location[1];
              var lon = this.data[i].location[0];

              var latlngset = new google.maps.LatLng(lat, lon);
              if (this.data[i].purpose === "observation") {
                var iconBase =
                  "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
              }
              if (this.data[i].purpose === "rescue") {
                var iconBase =
                  "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
              }

              marker = new google.maps.Marker({
                map: vm.map,
                position: latlngset,

                icon: iconBase,
              });
              // vm.Marker[i] = {
              //   m: marker,

              // }

              var content =
                '<table><tr><td colspan=2 style="padding-left:10px;"><p style="color:#ff6907;">Purpose: ' +
                this.data[i].purpose +
                '</p><p><a style="color:#333333">state: ' +
                this.data[i].state +
                "</a></p></td></tr></table>";

              var infowindow = new google.maps.InfoWindow();

              google.maps.event.addListener(
                marker,
                "click",
                (function (marker, content, infowindow) {
                  return function () {
                    infowindow.setContent(content);
                    infowindow.open(vm.map, marker);
                  };
                })(marker, content, infowindow)
              );

              this.loading = false;
            }
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
          // this.errors.push(e)
          // this.msg = 'failed'
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();
      var strTime = month + "-" + day + "-" + year;
      return strTime;
    },
  },
};
</script>
<style>
#myMap {
  height: 500px !important;
  width: 100%;
}
</style>